import React from 'react';

const ValuePillars = ({ t }) => {
  const pillars = [
    { title: t.pillars.discipline.title, description: t.pillars.discipline.description },
    { title: t.pillars.location.title, description: t.pillars.location.description },
    { title: t.pillars.execution.title, description: t.pillars.execution.description }
  ];

  return (
    <section data-testid="value-pillars-section" className="py-12 sm:py-16 lg:py-20 bg-white border-t border-gray-100">
      <div className="container mx-auto px-5 sm:px-6 lg:px-8 max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 lg:gap-14">
          {pillars.map((pillar, index) => (
            <div key={pillar.title}>
              <div className="w-8 h-px bg-gray-300 mb-5" />
              <h3 className="text-sm font-medium text-gray-900 mb-3 tracking-wide uppercase">
                {pillar.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuePillars;
